// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1vK75","footer":"ModalFilter_footer__3hchs"};